import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import DeviceNameBreadcrumbs from 'components/DeviceNameBreadcrumbs';

/**
 * Column for the device name.
 */
export default function DeviceNameColumn({ data: { device } }: { data: RevisionPlanRow }) {
  return <DeviceNameBreadcrumbs {...device} />;
}
